module.exports = __webpack_public_path__ + "img/hand-right.09743151.svg";